import { PropsWithChildren } from 'react';
import { Text } from '~/components/typography';
import { StyledContainer, StyledLabel } from './disabled-input.style';
// TODO: move to Shrike 2021/ directory

export type DisabledInputProps = PropsWithChildren<{
  label?: string;
  testId?: string;
  helperText?: string;
}>;

export const DisabledInput = ({ children, label, testId, helperText = '' }: DisabledInputProps) => {
  return (
    <StyledLabel fontFamily="medium">
      {label}
      <StyledContainer testId={testId}>{children}</StyledContainer>
      {!!helperText && (
        <Text color="primary" fontWeight="500" fontSize="12px" mt={1}>
          {helperText}
        </Text>
      )}
    </StyledLabel>
  );
};
